import { useMemo } from 'react';
import useClient from './useClient';
import { useFetchQuotationUserGnbQuery } from '@generated/graphql';
import useBrowserVisiblity from './useBrowserVisiblity';

export default function useGnbCount() {
  const {
    clientState: { accessToken }
  } = useClient();

  const {
    data,
    startPolling,
    stopPolling,
    refetch: fetchQuotationUserGnb
  } = useFetchQuotationUserGnbQuery({
    skip: !accessToken
  });

  useBrowserVisiblity({
    onVisible: () => {
      fetchQuotationUserGnb();
      startPolling(3000);
    },
    onInVisible: () => stopPolling()
  });

  const gnbCount: GnbCount = useMemo(() => {
    const gnbStatusInfo = data?.fetchQuotationUserGNB?.data;
    const newChatCount = gnbStatusInfo?.newChatCount ?? 0;
    const newQuotationAndIntroductionCount =
      gnbStatusInfo?.newQuotationAndIntroductionCount ?? 0;
    const newPaymentManagementCount =
      gnbStatusInfo?.newPaymentManagementCount ?? 0;

    return {
      newChatCount,
      newQuotationAndIntroductionCount,
      newPaymentManagementCount
    };
  }, [data]);

  return {
    gnbCount
  };
}

export type GnbCount = {
  newChatCount: number;
  newQuotationAndIntroductionCount: number;
  newPaymentManagementCount: number;
};
